module.exports = __webpack_public_path__ + "img/processing-05.772657a5.gif";